import { createContext, useEffect, useState } from 'react';
import { getCompanyChoice, saveCompanyChoice } from './session';

export const defaultMe = (whoami) => {
	let defaultMe = null
	if (whoami) {
		const savedCompany_id = getCompanyChoice()
		if(savedCompany_id && savedCompany_id in whoami["user"]){
			defaultMe = {
				...whoami["user"][savedCompany_id],
				...whoami["companies"].find(c => c.id === savedCompany_id)
			}
		}else{
			const firstCompanyId = Object.keys(whoami["user"])[0]
			defaultMe = {
				...whoami["user"][firstCompanyId],
				...whoami["companies"].find(c => c.id === firstCompanyId)
			}
		}
	}
	return defaultMe
}

const MeContext = createContext()

export const useMe = (initData) => {
	const [whoami, setWhoami] = useState(initData)
	const [me, setMe] = useState(defaultMe(whoami))

	const setCompany = (id) => {
		saveCompanyChoice(id)
		setMe({
			...whoami.user[id],
			...whoami.companies.find(c => c.id === id)
		})
	}

	useEffect(() => {
		setMe(defaultMe(whoami))
		
	}, [whoami])

	return {
		me,
		setMe,
		setCompany,
		whoami,
		setWhoami
	}
}

export default MeContext 
